import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-trash-bin icon-trash-empty",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15,2.68h-3.79V.5H4.79V2.68H1v1.3h1.29l.87,11.52H12.84l.87-11.52h1.29v-1.3h0ZM6.1,1.8h3.8v.88h-3.8v-.88Zm5.54,12.39H4.37L3.59,3.98H12.41l-.77,10.21Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7.48",
  y: "6.21",
  width: "1.04",
  height: "5.76"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "5.48",
  y: "6.21",
  width: "1.04",
  height: "5.76"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "9.48",
  y: "6.21",
  width: "1.04",
  height: "5.76"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}